import React from "react";
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
import userManager from "../../helpers/UserManagerHelper";
import { Paths } from "../../constants/UrlConstants";
import {
  LoginStatus,
  B2CErrorResponseCodes,
  B2COIDCClientStateNotFoundError,
  B2COIDCClientIatIsInFutureError,
  B2COIDCClientExpIsInPastError
} from "../../constants/Constants";
import {
  doB2CInternalViewLogin,
  setMemberDetailUpdated
} from "../../actions/account/accountActions";
import { setErrorMessage } from "../../actions/error/errorActions";
import {
  setDeepLinkingUrl,
  setSelectedPolicyMembershipNumber
} from "../../actions/policy/policyActions";
import { decodeB2CErrorMessage } from "../../helpers/B2CErrorMessageDecoder";
import {
  ResetB2CPassword,
  RedirectToLogin
} from "../../helpers/AccountsHelper";
import { trackException } from "../../logging/AppInsightsLogger";

export const b2cErrorMessage =
  "Something went wrong while user authenticating through B2C";

export class AuthCallBack extends React.Component {
  successCallback = ({ profile = {}, state = {} }) => {
    window.embeddedservice_bootstrap?.userVerificationAPI?.clearSession(true);
    if (state.internalviewtoken) {
      this.props
        .doB2CInternalViewLogin(state.internalviewtoken, this.props.history)
        .then((response) => {
          if (response && response.status === LoginStatus.SessionFailure) {
            localStorage.clear();
            sessionStorage.clear();
            this.props.history.push(Paths.InternalViewSessionExists);
          }
        });
    } else if (state.redirectPath) {
      this.props.setDeepLinkingUrl(state.redirectPath);
      if (state.memberDetailUpdated) {
        this.props.setMemberDetailUpdated({
          memberDetailUpdated: state.memberDetailUpdated
        });
      }
      if (state.selectedPolicyMembershipNumber) {
        this.props.setSelectedPolicyMembershipNumber(
          state.selectedPolicyMembershipNumber
        );
      }
      this.props.history.push(Paths.HomeRoot);
    } else if (Array.isArray(profile.policy) && profile.policy.length === 0) {
      this.props.history.push(Paths.MemberDetails);
    } else {
      this.props.history.push(Paths.HomeRoot);
    }
  };

  errorCallback = ({
    error_description = "",
    state = {},
    message = "No message found"
  }) => {
    if (message === B2COIDCClientStateNotFoundError) {
      RedirectToLogin();
    } else if (
      message.includes(B2COIDCClientIatIsInFutureError) ||
      message.includes(B2COIDCClientExpIsInPastError)
    ) {
      trackException(b2cErrorMessage, message);
      this.props.history.push(Paths.TimeSetting);
    } else if (error_description.length > 0) {
      if (error_description.includes(B2CErrorResponseCodes.ForgottenPassword)) {
        ResetB2CPassword();
      } else if (
        error_description.includes(B2CErrorResponseCodes.CancelButton)
      ) {
        if (state.redirectPath) {
          if (state.selectedPolicyMembershipNumber) {
            this.props.setSelectedPolicyMembershipNumber(
              state.selectedPolicyMembershipNumber
            );
          }
          this.props.setDeepLinkingUrl(state.redirectPath);
        }
        this.props.history.push(Paths.HomeRoot);
      } else {
        let decodedErrorDescription = decodeB2CErrorMessage(error_description);
        trackException(b2cErrorMessage, decodedErrorDescription);
        this.props.setErrorMessage(decodedErrorDescription);
        this.props.history.push(Paths.Error);
      }
    } else {
      trackException(b2cErrorMessage, message);
      this.props.history.push(Paths.Error);
    }
  };

  render() {
    return (
      <CallbackComponent
        userManager={userManager}
        successCallback={this.successCallback}
        errorCallback={this.errorCallback}
      >
        <div>Redirecting...</div>
      </CallbackComponent>
    );
  }
}

export default connect(null, {
  doB2CInternalViewLogin,
  setDeepLinkingUrl,
  setMemberDetailUpdated,
  setErrorMessage,
  setSelectedPolicyMembershipNumber
})(AuthCallBack);
